module.exports = __webpack_public_path__ + "img/prod_info_zhyyxcx.d9457003.png";